// @flow

import gql from 'graphql-tag';

const appPromoQuery = gql`
  query appPromoQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      image
      name
      slug
      currentImplementation {
        id
      }
    }
  }
`;

export default appPromoQuery;
